export class EntityModel {
  id: any;
}
